// src/pages/LabelTemplateEditorPage.jsx
import React, { useMemo } from "react";
import { useParams, useNavigate } from "react-router-dom";
import LabelTemplateEditor from "../components/labels/LabelTemplateEditor";
import {
  useAddLabelTemplateMutation,
  useUpdateLabelTemplateMutation,
  useGetLabelTemplateByIdQuery,
} from "../toolkitServices/labelTemplateApi";
import toast from "react-hot-toast";

const LabelTemplateEditorPage = () => {
  const navigate = useNavigate();
  const { id } = useParams(); // route: /settings/label-templates/:id/edit
  const isEdit = Boolean(id);

  // 👉 Edit ke time template fetch
  const {
    data: tplRes,
    isLoading: isTemplateLoading,
    isError: isTemplateError,
  } = useGetLabelTemplateByIdQuery(id, {
    skip: !isEdit,
  });

  // API ka shape depend karega (data ya direct object)
  const initialTemplate = useMemo(() => {
    if (!isEdit) return undefined;
    if (!tplRes) return undefined;
    // backend agar { data: {...} } de raha ho:
    return tplRes.data || tplRes;
  }, [isEdit, tplRes]);

  const [addLabelTemplate, { isLoading: isAdding }] =
    useAddLabelTemplateMutation();
  const [updateLabelTemplate, { isLoading: isUpdating }] =
    useUpdateLabelTemplateMutation();

  const isSaving = isAdding || isUpdating;

  const handleSaveTemplate = async (template) => {
    try {
      const basePayload = {
        name: (template.name || "").trim() || "Untitled Label",
        widthMm: template.widthMm,
        heightMm: template.heightMm,
        dpi: template.dpi || 96,
        elements: template.elements || [],

        // 🔹 IMPORTANT: scope bhi payload me bhejna
        branchIds: template.branchIds || [],
        categoryIds: template.categoryIds || [],
      };

      if (isEdit) {
        // 🔁 UPDATE FLOW
        await updateLabelTemplate({
          id,
          ...basePayload,
        }).unwrap();
        toast.success("Label template updated successfully!");
      } else {
        // ➕ CREATE FLOW
        await addLabelTemplate(basePayload).unwrap();
        toast.success("Label template created successfully!");

        // Agar backend new _id return kare to waha redirect bhi kar sakte:
        // const newId = res?.data?._id || res?._id;
        // if (newId) navigate(`/settings/label-templates/${newId}/edit`);
      }

      // List pe wapas
      navigate("/designs/label/List");
    } catch (err) {
      console.error("Error saving label template:", err);
      const msg =
        err?.data?.message ||
        err?.data?.error ||
        err?.error ||
        "Failed to save label template";
      toast.error(msg);
    }
  };

  // Edit mode me jab tak data aata nahi tab ek simple loader
  if (isEdit && isTemplateLoading) {
    return (
      <div className="h-full flex items-center justify-center text-sm text-slate-500">
        Loading template…
      </div>
    );
  }

  if (isEdit && isTemplateError) {
    return (
      <div className="h-full flex flex-col items-center justify-center text-sm text-red-500">
        Failed to load template for editing.
      </div>
    );
  }

  return (
    <LabelTemplateEditor
      initialTemplate={initialTemplate}
      onSave={handleSaveTemplate}
      isSaving={isSaving}
    />
  );
};

export default LabelTemplateEditorPage;
